import { DataGrid } from "@mui/x-data-grid";
import { getFinalAccounting } from "./api";
import { useEffect, useState } from "react";

export default function FinalPage() {
  const [rows, setRows] = useState([]);
  const [weeks, setWeeks] = useState([]);

  const fetchFinalAccounting = async () => {
    const data = await getFinalAccounting();
    setRows(data.rows);
    setWeeks(data.weeks);
  }

  useEffect(() => {
    fetchFinalAccounting();  
  }, []);

  const baseColumns = [
    { field: "rnr_code", headerName: "RNR", width: 100 },
    { field: "description", headerName: "Description", width: 250 },
  ];

  const weekColumns = weeks.map(w => {
    // convert to Date objects
    const start = new Date(w.start);
    const end = new Date(w.end);

    // format as DD-MM-YYYY
    const formatDate = (d) =>
      `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
        
    return {
      field: `week_${w.week_id}`,
      renderHeader: () => (
        <div style={{ whiteSpace: 'normal', textAlign: 'left' }}>
          {formatDate(start)}&mdash;<br/>{formatDate(end)}
        </div>
      ),
      width: 130,
      type: "number",
      sortable: false,
    };
  });

  const columns = [...baseColumns, ...weekColumns];

  const specialRows = ["1000", "2000", "3000", "4001", "4002"];


  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={r => r.id}
      getRowClassName={(params) =>
        specialRows.includes(params.row.rnr_code)
          ? `rnr-${params.row.rnr_code}`
          : ""
      }
      sx={{
        '& .MuiDataGrid-columnHeaderTitle': {
          whiteSpace: 'normal',  // allow wrapping
          lineHeight: '1.2em',
          textAlign: 'left'
        }
      }}
    />
  );

}
